export default "__VITE_PUBLIC_ASSET__e827a4eb__"